import * as exercisesConstants from './exercises';
export const exercises = exercisesConstants;